// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/modern-normalize/modern-normalize.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Inter Tight", system-ui, sans-serif;
  font-size: 16px;
  color: #202124;
}
`, "",{"version":3,"sources":["webpack://./src/client/index.css"],"names":[],"mappings":"AAGA;EACE,iDAAiD;EACjD,eAAe;EACf,cAAc;AAChB","sourcesContent":["@import \"modern-normalize/modern-normalize.css\";\n@import url(\"https://fonts.googleapis.com/css2?family=Inter+Tight:wght@400;500;700&display=swap\");\n\nbody {\n  font-family: \"Inter Tight\", system-ui, sans-serif;\n  font-size: 16px;\n  color: #202124;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
